/**
 * Menu Componenets
 *
 * @file menu.js
 */


const menu = (() => {
  // Services Page Project List
  const simpleMenu = () => {
  };

  const init = () => {
    simpleMenu();
  };

  return {
    init,
  };
})();

export default menu;
